import { cEl } from '../../../../util';
import { navigateTo } from '../../../AppHeader/Link';
import { PATH_ADMIN_MANAGEMENT_CHANGE_PASSWORD } from '../../../path';

function ManagementMenus() {
    const manuContainer = cEl('div');
    manuContainer.classList.add('menu-container');

    const changePasswordMenu = cEl('button');
    changePasswordMenu.classList.add('button', 'default-button', 'menu-button');
    changePasswordMenu.innerHTML = '관리자 비밀번호 수정';
    changePasswordMenu.addEventListener('click', () => {
        navigateTo(PATH_ADMIN_MANAGEMENT_CHANGE_PASSWORD);
    });

    manuContainer.append(changePasswordMenu);

    return manuContainer;
}

export default ManagementMenus;
